/* eslint-disable no-unused-vars */
import React, {Dispatch, SetStateAction} from 'react';
import {Observable} from 'rxjs';
import {Db} from '../../core/data/db';
import {RealTimes, RealTimeWorker} from '../../core/data/real-time-worker';
import {AlertModel, RouteModel, ServiceModel, StopModel, TripCoords} from '../../core/models';
import {PinModel} from '../../core/models/pin.model';


export interface DataCtx {
    db?: Db,
    ready: boolean,
    init: (element: HTMLElement) => Promise<Db>,
    pinSet: { [slug: string]: PinModel } | null,
    services: ServiceModel[],
    getCurrentStop: (id?: string) => void,
    currentStop: StopModel | null,
    visibleStops: StopModel[],
    closeStops: StopModel[],
    currentStopAlerts: AlertModel[],
    getCurrentRoute: (id?: string) => void,
    currentRoute: RouteModel | null,
    currentRouteAlerts: AlertModel[],
    currentStopEntries: StopModel[],
    currentTrip: number,
    setCurrentTrip: Dispatch<SetStateAction<number>>,
    tripCoords: TripCoords[],
    realTimes: RealTimes,
    realTimeWorker?: RealTimeWorker,
    getAllServiceCatalogFormated?: any,
    getStatusSlugFilter?: any,
    handleNearbyServices?: any,
    getLinesById?: any,
    getAllRecentSearches?: any,
    insertSearch?: any;
    updateSearch?: any;
    removeSearch?: any;
}

export const DataContext = React.createContext<DataCtx>(
    {
        ready: false,
        init: () => new Promise(Promise.resolve),
        pinSet: null,
        services: [],
        getCurrentStop: () => {
        },
        currentStop: null,
        visibleStops: [],
        closeStops: [],
        currentStopAlerts: [],
        getCurrentRoute: () => {
        },
        currentRoute: null,
        currentRouteAlerts: [],
        currentStopEntries: [],
        currentTrip: 0,
        setCurrentTrip: () => {
        },
        tripCoords: [],
        realTimes: {},
        realTimeWorker: undefined,
        getStatusSlugFilter: () => {
        },
        handleNearbyServices: () => {
        },
        getAllServiceCatalogFormated: () => {
        },
        getLinesById: () => {
        },
        getAllRecentSearches: () => {
        },
        insertSearch: () => {
        },
        updateSearch: () => {
        },
        removeSearch: () => {
        },
    },
);

export const DataProvider = DataContext.Provider;
